module.exports = __webpack_public_path__ + "img/image130.7073d5e1.png";